<div class="login-register">
    <div class="login-register-box error-card text-center">
        <h1>404</h1>
        <h3 class="text-uppercase">Oh no!</h3>
        <p class="m-t-30 m-b-30">We looked everywhere, but couldn't find what you're asking for.</p>
        <a mat-raised-button color="primary" (click)="back()" class="m-r-10">Back</a>
        <a mat-raised-button color="primary" [routerLink]="['/dashboard']" class="btn btn-info btn-rounded waves-effect waves-light m-b-40"><mat-icon>home</mat-icon></a>
    </div>
</div>
